"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), Object.defineProperty(exports, "EventSourceOpenParametersType", {
  enumerable: !0,
  get: function get() {
    return _types.EventSourceOpenParametersType;
  }
}), Object.defineProperty(exports, "IEventSource", {
  enumerable: !0,
  get: function get() {
    return _eventSource.IEventSource;
  }
}), Object.defineProperty(exports, "IExternalEventSource", {
  enumerable: !0,
  get: function get() {
    return _types.IExternalEventSource;
  }
}), Object.defineProperty(exports, "KameleoonEventSource", {
  enumerable: !0,
  get: function get() {
    return _eventSource.KameleoonEventSource;
  }
}), Object.defineProperty(exports, "REAL_TIME_EVENT", {
  enumerable: !0,
  get: function get() {
    return _constants.REAL_TIME_EVENT;
  }
}), Object.defineProperty(exports, "RealTimeEventType", {
  enumerable: !0,
  get: function get() {
    return _types.RealTimeEventType;
  }
});
var _types = require("./types"),
  _eventSource = require("./eventSource"),
  _constants = require("./constants");